import Screen from '../../../demo/Screen';
import { STEPS } from '../../../demo/steps';
import './sai-product.css';

/*
 * The frame of a ported sai product page, in place of his DeckFrame and
 * ProductShell: our <Screen> (ready marker, title, visit, our shell around it)
 * and the `.sai-product` wrapper that scopes his styles and carries the page's
 * data-trapezium-state.
 *   screenId — our screen ID (e.g. product.smart-reports)
 *   title    — document title; defaults to the step's title in STEPS
 *   state    — the page's data-trapezium-state
 */
export default function SaiProductFrame({ screenId, title, state, children }) {
  const step = STEPS.find((s) => s.screenId === screenId);
  return (
    <Screen id={screenId} title={title || (step ? step.title : screenId)} className="sai-screen">
      <div className="sai-product" data-trapezium-state={state}>
        {children}
      </div>
    </Screen>
  );
}

/*
 * The step after `screenId` in our walkthrough, if it is still a product page
 * (his "Next product"). None after the last product, as on his intelligence page.
 */
export function nextProductAfter(screenId) {
  const i = STEPS.findIndex((s) => s.screenId === screenId);
  const next = i === -1 ? undefined : STEPS[i + 1];
  return next && next.section === 'product' ? next : undefined;
}
